import { OASMetaElements } from './meta-elements';

export default OASMetaElements;
